import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import '../chartStyle.css';
import SliderWithInput from '../../SliderWithInput';
import SwitchWithInput from '../../SwitchWithInput';
import { Dispatch } from 'redux';
import { updateGeoChartStyleOptions } from '../../../../redux/ChartPoperties/ChartControlsActions';
import { ChartOptionsProps, ChartOptionsStateProps } from '../../CommonInterfaceForChartOptions';
import { ChartConGeoChartControls } from '../../../../redux/ChartPoperties/ChartControlsInterface';

// import CSS from "csstype";

const textFieldInputProps = {
  style: {
    height: '2rem',
    flex: 1,
    padding: '4px 8px 2px 8px',
    width: '4rem',
    fontSize: '14px',
  },
};

const inputBaseStyle = {
  border: '2px solid rgba(224,224,224,1)',
  borderRadius: '3px',
  height: '20px',
  fontSize: '12px',
  padding: '0px 4px',
  color: '#a7a7a7',
};

interface GeoChartAction {
  updateGeoChartStyleOptions: (propKey: string, option: string, value: any) => void;
}

const BubbleMapStyles = ({
  // state
  chartControls,
  tabTileProps,

  // dispatch
  updateGeoChartStyleOptions,
  iconColor,
}: ChartOptionsProps & GeoChartAction & { iconColor?: string }) => {
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  var geoStyle: ChartConGeoChartControls = chartControls.properties[propKey].geoChartControls || {};
  // const [isColorPopoverOpen, setColorPopOverOpen] = useState(false);
  const [color, setColor] = useState<string>('');
  // const [colorFieldName, setColorFieldName] = useState<string>('');
  const [selectedSeparator, setSelectedSeparator] = useState<string>('None');

  const separatorOptions = [
    { type: 'None', value: 'None' },
    { type: 'Comma', value: 'Comma' },
    { type: 'Abbrev', value: 'Abbrev' },
  ];

  useEffect(() => {
    if (geoStyle.isDivergentFormat) {
      setSelectedSeparator(geoStyle.isDivergentFormat);
    }
  }, [geoStyle.isDivergentFormat]);

  return (
    <div className="optionsInfo">
      <div
        className="optionDescription"
        style={{ paddingTop: '0', marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
      >
        Map Zoom
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={geoStyle.mapZoom}
        sliderMinMax={{ min: 1, max: 5, step: 0.1 }}
        changeValue={(value) => {
          const rounded = Math.round(value * 10) / 10;
          updateGeoChartStyleOptions(propKey, 'mapZoom', rounded);
        }}
      />

      <div
        className="optionDescription"
        style={{ marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
      >
        Aspect Scale
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={geoStyle.aspectScale}
        sliderMinMax={{ min: 0.5, max: 10, step: 0.05 }} //max:3
        changeValue={(value) => {
          const rounded = Math.round(value * 10) / 10;
          updateGeoChartStyleOptions(propKey, 'aspectScale', rounded);
        }}
      />

      <div
        className="optionDescription"
        style={{ marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
      >
        Border Width
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={geoStyle.boderWidth}
        sliderMinMax={{ min: 1, max: 10, step: 0.5 }}
        changeValue={(value) => updateGeoChartStyleOptions(propKey, 'boderWidth', value)}
      />

      <div style={{ borderBottom: '1px solid #ccc', marginBottom: '10px', marginTop: '25px' }} />

      <div
        className="optionDescription"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '0.2rem',
          marginTop: '0px',
          overflowX: 'hidden',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        <label
          className="enableDisableLabel"
          style={{ fontWeight: 600, color: iconColor ? iconColor : '#404040' }}
        >
          Bubble Border
        </label>
        <div
          style={{
            width: '50px',
            height: '24px',
            display: 'flex',
            transform: 'translateX(63px)',
            marginBottom: '2px',
          }}
        >
          <SwitchWithInput
            isChecked={geoStyle.enableBubbleBorder || false}
            onSwitch={() => {
              updateGeoChartStyleOptions(
                propKey,
                'enableBubbleBorder',
                !geoStyle.enableBubbleBorder,
              );
            }}
          />
        </div>
      </div>

      {geoStyle.enableBubbleBorder && (
        <>
          <div
            className="optionDescription"
            style={{ marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
          >
            Bubble Border Width
          </div>
          <SliderWithInput
            sliderValue={geoStyle.bubbleBorderWidth || 2}
            sliderMinMax={{ min: 1, max: 10, step: 0.5 }}
            changeValue={(val) => updateGeoChartStyleOptions(propKey, 'bubbleBorderWidth', val)}
          />
        </>
      )}
      <div
        className="optionDescription"
        style={{ marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
      >
        Bubble Opacity
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={geoStyle.opacity || 70}
        sliderMinMax={{ min: 30, max: 100, step: 0.5 }}
        changeValue={(value) => updateGeoChartStyleOptions(propKey, 'opacity', value)}
      />
      <div
        className="optionDescription"
        style={{ marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
      >
        Max Bubble Size
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={geoStyle.maxBubbleSize}
        sliderMinMax={{ min: 1, max: 50, step: 0.5 }} //max:100
        changeValue={(value) => {
          updateGeoChartStyleOptions(propKey, 'maxBubbleSize', value);
          if (value - geoStyle.minBubbleSize < 0) {
            updateGeoChartStyleOptions(propKey, 'minBubbleSize', value);
          }
        }}
      />

      <div
        className="optionDescription"
        style={{ marginTop: '10px', color: iconColor ? iconColor : '#404040' }}
      >
        Min Bubble Size
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={geoStyle.minBubbleSize}
        sliderMinMax={{ min: 1, max: 50, step: 0.5 }} //max: geoStyle.maxBubbleSize
        changeValue={(value) => {
          const maxValue = geoStyle.maxBubbleSize;
          if (value + 1 < maxValue) {
            updateGeoChartStyleOptions(propKey, 'minBubbleSize', value);
          }
        }}
      />

      <div
        className="optionDescription"
        style={{ marginTop: '15px', color: iconColor ? iconColor : '#404040' }}
      >
        EMPHASIS ON MOUSEOVER:
      </div>

      <div
        className="optionDescription"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '0.4rem',
          marginTop: '0px',
          marginBottom: '0',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        <div style={{ width: '40%', height: '1.25rem', fontWeight: '400' }}>Blur Others</div>
        <div
          style={{
            width: '50px',
            height: '24px',
            display: 'flex',
            transform: 'translateX(63px)',
            marginBottom: '2px',
          }}
        >
          <SwitchWithInput
            isChecked={geoStyle.enableSelfEmphasis}
            onSwitch={() => {
              updateGeoChartStyleOptions(
                propKey,
                'enableSelfEmphasis',
                !geoStyle.enableSelfEmphasis,
              );
            }}
          />
        </div>
      </div>

      {/* <div className="optionDescription" style={{ marginTop: '15px' }}>
        Visual Scale
      </div>

      <div style={{ marginLeft: '-45px', marginTop: '5px' }}>
        <SwitchWithInput
          isChecked={geoStyle.showVisualScale}
          onSwitch={() => {
            updateGeoChartStyleOptions(propKey, 'showVisualScale', !geoStyle.showVisualScale);
          }}
        />
      </div>

      <div className="optionDescription" style={{ marginTop: '5px' }}>
        Separator
      </div>

      <div
        className="radioButtons"
        style={{
          padding: '0',
          display: 'flex',
          marginTop: '5px',
          marginLeft: '6px',
          marginRight: '6px',
          marginBottom: '10px',
        }}
      >
        {separatorOptions.map((item: any) => {
          const isSelected = item.value === selectedSeparator;

          return (
            <div
              key={item.value}
              style={{
                backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
                cursor: isSelected ? 'auto' : 'pointer',
                fontWeight: isSelected ? '600' : 'normal',
              }}
              className="radioButton"
              onClick={() => {
                setSelectedSeparator(item.value);
                updateGeoChartStyleOptions(propKey, 'isDivergentFormat', item.value);
              }}
            >
              {item.type}
            </div>
          );
        })}
      </div> */}

      {/* <div className="optionDescription">
        <div style={{ width: '40%', height: '1.25rem', fontWeight: '400', marginTop: '-35px' }}>
          Show Scale
        </div>
        <div style={{ width: '50%', height: '1.25rem', marginTop: '15px', marginLeft: '-25px' }}>
          <SwitchWithInput
            isChecked={geoStyle.showVisualScale}
            onSwitch={() => {
              updateGeoChartStyleOptions(propKey, 'showVisualScale', !geoStyle.showVisualScale);
            }}
          />
        </div>
      </div> */}
    </div>
  );
};
const mapStateToProps = (state: ChartOptionsStateProps, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateGeoChartStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateGeoChartStyleOptions(propKey, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BubbleMapStyles);
